import { ConfigurableText } from '@/app/components'
import Button from '@/components/Button/Button'
import { Modal } from '@/components'

interface DataUsageModalProps {
  open: boolean
  onClose: () => void
}

export const DataUsageModal = ({ open, onClose }: DataUsageModalProps) => {
  return (
    <Modal
      id="data-usage-modal"
      open={open}
      onClose={onClose}
      hideCloseButton={false}
      className="!max-w-md"
      title="Data Usage"
    >
      <div className="flex flex-col gap-4">
        <ConfigurableText variant="body2">
          Optiwatt collects and uses your data solely to enhance your EV
          charging experience. This includes analyzing charging patterns, energy
          rates, and vehicle usage to optimize savings and efficiency. Your data
          is encrypted, never shared with third parties without consent, and
          handled responsibly in compliance with strict privacy and security
          standards.
        </ConfigurableText>
        <Button
          variant="primary"
          onClick={onClose}
          className="w-full"
          id="data-usage-modal-ok-button"
        >
          OK
        </Button>
      </div>
    </Modal>
  )
}

export default DataUsageModal
